// Clickable column header for the client-sorted list tables. Same three-state
// affordance as the Sites table: idle, ascending, descending.

import { ChevronUp, ChevronDown, ChevronsUpDown } from 'lucide-react';
import { cn } from '../../../../foundation/altzero_base/base/lib/utils';
import type { SortDir } from '../../utils/tableSort';

type Props<F extends string> = {
  label: string;
  field: F;
  sortField: F | null;
  sortDir: SortDir;
  onSort: (field: F) => void;
  className?: string;
};

export function SortableTh<F extends string>({
  label, field, sortField, sortDir, onSort, className,
}: Props<F>) {
  const active = sortField === field;
  return (
    <th
      className={cn(
        'px-4 py-3 cursor-pointer select-none whitespace-nowrap hover:text-gray-700',
        active && 'text-gray-700',
        className,
      )}
      onClick={() => onSort(field)}
      title={`Sort by ${label}`}
      aria-sort={active ? (sortDir === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      {label}
      {!active
        ? <ChevronsUpDown className="h-3 w-3 ml-1 opacity-30 inline" />
        : sortDir === 'asc'
          ? <ChevronUp className="h-3 w-3 ml-1 text-blue-500 inline" />
          : <ChevronDown className="h-3 w-3 ml-1 text-blue-500 inline" />}
    </th>
  );
}
